import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import axios from "axios";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Cateringsettelments = () => {
    const [dataa, setDataa] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedDate, setSelectedDate] = useState("");
    const isMobile = useState(window.innerWidth < 768);
    useEffect(() => {
        const fetchData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId || !token) {
                setError("Missing vendorId or token");
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(
                    `http://testing.maamaas.com:8080/catering/api/vendor/settlements/get/${vendorId}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const transformed = response.data.map((item, index) => ({
                    sno: index + 1,
                    settlementId: item.settlementId,
                    transactionId: `${item.settlementId}`,
                    totalCgst: item.totalCgst,
                    totalGrandTotal: item.totalGrandTotal,
                    totalAmountBeforeTds: item.totalAmountBeforeTds,
                    tdsAmount: item.tdsAmount,
                    amountAfterTds: item.amountAfterTds,
                    holderName: item.holderName || "NA",
                    accountNumber: item.accountNumber || "NA",
                    ifscCode: item.ifscCode || "NA",
                    settlementDate: item.settlementDate,
                    paymentStatus: item.paymentStatus || "PENDING",
                    remarks: item.remarks || "NA",
                    superAdminAccountNo: item.superAdminAccountNo || "NA",
                }));

                setDataa(transformed);
                setFilteredData(transformed);
                setLoading(false);
            } catch (err) {
                console.error("❌ Error fetching settlements:", err);
                setError("Failed to fetch settlements");
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Filter based on selectedDate
    useEffect(() => {
        if (!dataa.length) return;

        const filtered = dataa.filter((item) => {
            if (selectedDate) {
                return dayjs(item.settlementDate).isSame(dayjs(selectedDate), "day");
            }
            return true;
        });

        setFilteredData(filtered);
    }, [selectedDate, dataa]);

    // Export filtered data to Excel
    const handleExportExcel = () => {
        if (!filteredData.length) return;

        // Convert data to a format suitable for Excel
        const exportData = filteredData.map(item => ({
            "S.No": item.sno,
            "Transaction ID": item.transactionId,
            "Total CGST": item.totalCgst,
            "Grand Total": item.totalGrandTotal,
            "Total Sales": item.totalAmountBeforeTds,
            "TDS Amount": item.tdsAmount,
            "To Settle": item.amountAfterTds,
            "Admin Acc": item.superAdminAccountNo,
            "Vendor Name": item.holderName,
            "Vendor Acc": item.accountNumber,
            "Settlement Date": item.settlementDate,
            "Remarks": item.remarks,
            "Payment Status": item.paymentStatus
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Settlements");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, `Settlements_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div>
            {/* Date Picker / Export Buttons */}
            <div style={{ display: "flex", gap: 10, justifyContent: "space-between", marginTop: -15 }} >
                <div>
                    <input
                        type="date"
                        style={{ ...selectStyle, padding: "0 5px" }}
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                </div>
                <div>
                    <button style={btnStyle} onClick={handleExportExcel}>Export Excel</button>
                </div>
            </div>

            {/* Settlement Table */}
            <div style={{
                overflow: 'auto',
                // height: isMobile ? '700px' : '520px',
                // scrollbarWidth: "none",
                // msOverflowStyle: "none",
                maxWidth: '944px',
                marginTop: "15px"
            }} className="caetring-settlemts-data">
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 0 }}>
                    <thead>
                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                            {[
                                "S.No", "TransactionID", "Total CGST", "Grand Total", "Total Sales",
                                "TDS Amount", "To Settle", "Admin Acc", "Vendor Name",
                                "Vendor Acc", "Settlement Date",
                            ].map((h) => (
                                <th key={h} style={thStyle}>{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr key={item.settlementId} style={index % 2 === 0 ? evenRowStyle : oddRowStyle}>
                                <td style={tdStyle}>{item.sno}</td>
                                <td style={tdStyle}>{item.transactionId}</td>
                                <td style={tdStyle}>{item.totalCgst}</td>
                                <td style={tdStyle}>{item.totalGrandTotal}</td>
                                <td style={tdStyle}>{item.totalAmountBeforeTds}</td>
                                <td style={tdStyle}>{item.tdsAmount}</td>
                                <td style={tdStyle}>{item.amountAfterTds}</td>
                                <td style={tdStyle}>{item.superAdminAccountNo}</td>
                                <td style={tdStyle}>{item.holderName}</td>
                                <td style={tdStyle}>{item.accountNumber}</td>
                                <td style={tdStyle}>{item.settlementDate}</td>
                                {/* <td style={tdStyle}>
                                    {item.paymentStatus === "SUCCESS" ? (
                                        <button onClick={() => handleDownload(item)} style={downloadBtn}>Download</button>
                                    ) : "—"}
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

/* Styles */
const thStyle = { border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", backgroundColor: "#b15cd6", color: "white" };
const tdStyle = { border: "1px solid #ddd", textAlign: "center", padding: 4 };
const evenRowStyle = { backgroundColor: "#f9f9f9" };
const oddRowStyle = { backgroundColor: "#fff" };
const selectStyle = { height: 35, marginTop: 20, borderRadius: 4, fontWeight: "bold", backgroundColor: "#b15cd6", color: "#fff" };
const btnStyle = { height: 35, marginTop: 20, borderRadius: 4, border: "none", backgroundColor: "#b15cd6", color: "white", fontWeight: "bold", padding: "0 16px" };
const downloadBtn = { padding: "4px 8px", border: "none", borderRadius: 4, backgroundColor: "#b15cd6", color: "#fff", cursor: "pointer" };

export default Cateringsettelments;
